import { Transition } from '@headlessui/react';
import { Fragment, type ReactNode, useEffect, useState } from 'react';

const Fade = ({ children, className }: { children: ReactNode; className?: string }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setOpen(true);
    }, 0);
  }, []);

  return (
    <Transition
      show={open}
      as={Fragment}
      enter="transition duration-300 ease-out"
      enterFrom="transform scale-90 opacity-0"
      enterTo="transform opacity-300 scale-100"
    >
      <div className={className}>{children}</div>
    </Transition>
  );
};

export { Fade };
